import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'topo-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
  @Input() bdColor: string = 'rgba(0,0,0,.1)';
  @Input() message: string;
  @Input() type: string = 'ball-pulse-sync';

  constructor() { }

  ngOnInit(): void { }
}
